import SearchWidget from '@package/components/SearchWidget';

export default SearchWidget;
